import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'arrow-left-icon',
  templateUrl: './arrow-left-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ArrowLeftIconComponent {}
